export const Books = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.26235 6.86719H6.34118C6.30728 6.86719 6.31481 6.93591 6.42195 6.99085C6.50767 7.0348 6.51987 7.18805 6.51525 7.25918V12.0205H8.47589V7.31231C8.40399 6.99415 7.84071 6.88299 7.56806 6.86719H7.26235Z"
      fill="url(#paint0_linear_5960_17594)"
    />
    <path
      d="M4.07388 5.1582H3.1527C3.1188 5.1582 3.12633 5.24972 3.23348 5.32288C3.31919 5.38141 3.33139 5.58547 3.32677 5.68019V12.0205H5.28742V5.75094C5.21551 5.32726 4.65223 5.17925 4.37958 5.1582H4.07388Z"
      fill="url(#paint1_linear_5960_17594)"
    />
    <path
      d="M0.93911 3.2207H0.017935C-0.0159656 3.2207 -0.00843209 3.33773 0.0987105 3.43129C0.184425 3.50613 0.196623 3.76709 0.192008 3.88821V11.9961H2.15265V3.97869C2.08074 3.4369 1.51747 3.24762 1.24481 3.2207H0.93911Z"
      fill="url(#paint2_linear_5960_17594)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.85713 1.73031H0V0.0195312H6.85713C7.70857 0.0195312 8.96666 0.267407 10.0365 1.03613C11.1501 1.83626 12 3.1623 12 5.15186V11.995H10.2857V5.15186C10.2857 3.71988 9.707 2.90744 9.03486 2.42449C8.31901 1.91013 7.43425 1.73031 6.85713 1.73031Z"
      fill="url(#paint3_linear_5960_17594)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5960_17594"
        x1="6.32324"
        y1="9.44383"
        x2="8.47589"
        y2="9.44383"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5960_17594"
        x1="3.13477"
        y1="8.58935"
        x2="5.28742"
        y2="8.58935"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5960_17594"
        x1="0"
        y1="7.60841"
        x2="2.15265"
        y2="7.60841"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5960_17594"
        x1="0"
        y1="6.00725"
        x2="12"
        y2="6.00725"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
    </defs>
  </svg>
);
